module.exports = __webpack_public_path__ + "32d91df4d3dad4a8d27fdae1aa64dc23.png";